export enum ServiceOrderWorkflowTrigger {
  CREATED = "CREATED",
  ITEMS_CHANGED = "ITEMS_CHANGED",
  STATUS_CHANGED = "STATUS_CHANGED",
  COMMENT_ADDED = "COMMENT_ADDED",
  DELIVERY_DATE_CHANGED = "DELIVERY_DATE_CHANGED",
  DEPOSIT_PAID = "DEPOSIT_PAID",
  PAID = "PAID",
}
